import Cookies from 'js-cookie'

const TokenKey = 'tjulib_server_token'
const routerKey = "from_router"
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token,  { expires: 14 })
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getRouter(){
  return Cookies.get(routerKey)
}

export function setRouter(from_router){
  return Cookies.set(routerKey,from_router)
}

export function removeRouter(){
  return Cookies.remove(routerKey)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js